import "./TyiTabContent.scss";

const TyiTabContent = () => {};

export default TyiTabContent;
